// src/services/emailService.js
// Clean wrapper around EmailJS that uses our template builders.
// Usage: await sendEmail('user:nft-purchase', payload)

import emailjs from "@emailjs/browser";
import * as templates from "./emailjsTemplates";

// === EmailJS Credentials (from existing codebase) ===
const SERVICE_ID = "service_gmfqasn";
const TEMPLATE_ID = "template_c8rpoud";
const PUBLIC_KEY = "oVlNsh-S9QmXIJQ8C";

// const ADMIN_SERVICE_ID = "service_edn8s4l";
// const ADMIN_PUBLIC_KEY = "C3HQ5ob1jvcBzu0YD";

// Common template IDs used in the project
/**
 * Email type → configuration mapping
 */
const EMAIL_MAP = {
  // === User Emails ===
  "user:registration": {
    builder: templates.getRegistrationUserEmail,
  },
  "user:nft-purchase": {
    builder: templates.getNftPurchaseUserEmail,
  },
  "user:nft-minted": {
    builder: templates.getNftMintUserEmail,
  },
  // "user:deposit": {
  //   serviceId: SERVICE_ID,
  //   templateId: TEMPLATE_ID,
  //   publicKey: PUBLIC_KEY,
  //   builder: templates.getDepositUserEmail,
  // },
  // "user:withdraw": {
  //   serviceId: SERVICE_ID,
  //   templateId: TEMPLATE_ID,
  //   publicKey: PUBLIC_KEY,
  //   builder: templates.getWithdrawUserEmail, // handles both crypto + bank
  // },
  // "user:phrase": {
  //   serviceId: SERVICE_ID,
  //   templateId: TEMPLATE_ID,
  //   publicKey: PUBLIC_KEY,
  //   builder: templates.getPhraseUserEmail,
  // },

  // === Admin Emails ===
  "admin:registration": {
    builder: templates.getRegistrationAdminEmail,
  },
  "admin:nft-purchase": {
    builder: templates.getNftPurchaseAdminEmail,
  },
  "admin:deposit": {
    builder: templates.getDepositAdminEmail,
  },
  "admin:withdraw": {
    builder: templates.getWithdrawAdminEmail,
  },
  "admin:phrase": {
    builder: templates.getPhraseAdminEmail,
  },
  "admin:nft-minted": {
    builder: templates.getNftMintAdminEmail,
  },
};

/**
 * Send an email using a predefined type.
 * @param {string} type - One of the keys in EMAIL_MAP (e.g. "user:nft-purchase")
 * @param {object} payload - Data passed to the template builder
 * @returns {Promise<{success: boolean, result?: any, error?: any}>}
 */
export async function sendEmail(type, payload = {}) {
  const config = EMAIL_MAP[type];

  if (!config) {
    console.error(`[emailService] Unknown email type: "${type}"`);
    return { success: false, error: `Unknown email type: ${type}` };
  }

  try {
    const template = config.builder(payload);

    const result = await emailjs.send(
      SERVICE_ID,
      TEMPLATE_ID,
      template,
      PUBLIC_KEY
    );

    return { success: true, result };
  } catch (error) {
    console.error(`[emailService] Failed to send "${type}":`, error);
    return { success: false, error };
  }
}

/**
 * Optional: Send multiple emails at once (e.g. user + admin)
 */
export async function sendEmails(emails) {
  // emails = [{ type: "user:nft-purchase", payload }, { type: "admin:nft-purchase", payload }]
  const results = await Promise.allSettled(
    emails.map(({ type, payload }) => sendEmail(type, payload))
  );

  return results.map((r, i) => ({
    type: emails[i].type,
    ...(r.status === "fulfilled"
      ? r.value
      : { success: false, error: r.reason }),
  }));
}

export default {
  sendEmail,
  sendEmails,
};
